import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Modal } from '@powdr/components';
import {
  CarouselControlPlacement,
  CarouselPaginationPlacement,
  CarouselPaginationType,
  CarouselTransitionEffects,
} from '@powdr/constants';
import { getImageAltText } from '@powdr/utils';

import {
  StyledImageGrid, GridContainer, Image,
  ImageContainer, ImageOverlay, ViewAllButton,
  ImageCarousel, ImageAlignmentWrapper, MobileCarousel,
} from './styles';

export const ImageGrid = ({
  className,
  relationships,
  parentColorProfile,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const images = relationships?.images;

  return (
    <StyledImageGrid className={className}>
      {/* Desktop Grid */}
      <GridContainer>
        {images.map((image, idx) => (
          (idx <= 4) && (
            <ImageContainer className={(idx === 0) ? 'large-image' : `small-image-${idx}`} onClick={() => setModalOpen(true)}>
              <ImageOverlay className="image-overlay" />
              <Image
                alt={getImageAltText(image.relationships.image)}
                image={image.relationships.image.gatsbyImage}
              />
            </ImageContainer>
          )))}
      </GridContainer>

      {/* Mobile Carousel */}
      <MobileCarousel
        controlSettings={{
          iconName: 'ui-arrow-left',
          size: 15,
          placement: CarouselControlPlacement.ON_SLIDE,
        }}
        paginationSettings={{
          type: CarouselPaginationType.FRACTION,
          placement: CarouselPaginationPlacement.ON_SLIDE,
        }}
        isAutoHeight
        colorProfile={parentColorProfile}
      >
        {images.map((image) => (
          <ImageAlignmentWrapper colorProfile={parentColorProfile}>
            <Image alt={getImageAltText(image.relationships.image)} image={image.relationships.image.gatsbyImage} objectFit="contain" />
          </ImageAlignmentWrapper>
        ))}
      </MobileCarousel>

      {/* Desktop Modal Button */}
      <ViewAllButton onClick={() => setModalOpen(true)} colorProfile={parentColorProfile}>
        View All Images
      </ViewAllButton>

      {/* Carousel Modal */}
      {(isModalOpen) && (
        <Modal
          handleCloseModal={() => { setModalOpen(false); }}
          isFullScreen
          colorProfile={parentColorProfile}
        >
          <ImageCarousel
            controlSettings={{
              iconName: 'ui-arrow-left',
              size: 15,
              placement: CarouselControlPlacement.ON_SLIDE,
            }}
            paginationSettings={{
              type: CarouselPaginationType.FRACTION,
              placement: CarouselPaginationPlacement.ON_SLIDE,
            }}
            transitionEffect={CarouselTransitionEffects.FADE}
            colorProfile={parentColorProfile}
          >
            {images.map((image) => (
              <ImageAlignmentWrapper colorProfile={parentColorProfile}>
                <Image alt={getImageAltText(image.relationships.image)} image={image.relationships.image.gatsbyImage} objectFit="contain" />
              </ImageAlignmentWrapper>
            ))}
          </ImageCarousel>
        </Modal>
      )}
    </StyledImageGrid>
  );
};

ImageGrid.propTypes = {
  className: PropTypes.string,
  relationships: PropTypes.shape().isRequired,
  parentColorProfile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

ImageGrid.defaultProps = {
  className: '',
};
